import { useMutation } from '@tanstack/vue-query'

export default () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async (force?: boolean) =>
      await $fetch<string>(`/api/user/${authStore.user!.id}/send-verify-code`, {
        method: 'POST',
        body: JSON.stringify({ force }),
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
    onSuccess: () => {},
  })
}
